module.exports = __webpack_public_path__ + "img/Speaker=Rishan Lye.026156b0.png";